import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  PlusCircle,
  UserCircle2,
  FolderOpen,
  Settings as SettingsIcon,
  Film,
  Layers,
  Sparkles,
  Users,
  CalendarDays,
  LogOut,
} from "lucide-react";
import { api } from "@/lib/api";

const NAV_ITEMS = [
  { to: "/", label: "Dashboard", Icon: LayoutDashboard, testid: "nav-dashboard", end: true },
  { to: "/create", label: "Create Video", Icon: PlusCircle, testid: "nav-create" },
  { to: "/presets", label: "Launch Pack", Icon: Sparkles, testid: "nav-presets" },
  { to: "/series", label: "Series", Icon: Layers, testid: "nav-series" },
  { to: "/schedule", label: "Schedule", Icon: CalendarDays, testid: "nav-schedule" },
  { to: "/characters", label: "Characters", Icon: UserCircle2, testid: "nav-characters" },
  { to: "/family", label: "Family Cast", Icon: Users, testid: "nav-family" },
  { to: "/library", label: "Library", Icon: FolderOpen, testid: "nav-library" },
  { to: "/settings", label: "Settings", Icon: SettingsIcon, testid: "nav-settings" },
];

async function doLogout() {
  try { await api.post("/auth/logout"); } catch { /* ignore */ }
  window.location.replace("/login");
}

export default function Sidebar() {
  return (
    <aside
      data-testid="sidebar"
      className="sticky top-0 hidden h-screen w-64 shrink-0 flex-col border-r border-orange-100 bg-white/80 backdrop-blur md:flex"
    >
      <div className="flex items-center gap-3 px-6 py-6">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-orange-400 to-rose-400 text-white shadow-md">
          <Film className="h-5 w-5" />
        </div>
        <div>
          <div className="text-lg font-bold tracking-tight text-stone-800">
            Dom Studio
          </div>
          <div className="text-xs font-medium text-orange-700">
            kids content tool
          </div>
        </div>
      </div>
      <nav className="flex flex-1 flex-col gap-1 px-3 pb-4">
        {NAV_ITEMS.map(({ to, label, Icon, testid, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `group flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? "bg-gradient-to-r from-orange-100 to-rose-100 text-orange-800 shadow-sm"
                  : "text-stone-600 hover:bg-orange-50 hover:text-stone-800"
              }`
            }
          >
            <Icon className="h-4 w-4 shrink-0" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <button onClick={doLogout}
              className="mx-3 mb-2 flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-stone-600 hover:bg-red-50 hover:text-red-700 transition"
              data-testid="nav-logout">
        <LogOut size={16} /> Sign out
      </button>
      <div className="border-t border-orange-100 px-6 py-4 text-xs text-stone-500">
        {process.env.NODE_ENV === 'development' && 'Phase 7 · Scheduler + session auth'}
      </div>
    </aside>
  );
}
